import axios from 'axios';
import Qs from 'qs';
export const CALIBRATION_LOG_REQUEST = 'CALIBRATION_LOG_REQUEST';
export const WARNING_LOG_REQUEST = 'WARNING_LOG_REQUEST';
export const CALIBRATION_LOG_SUCCESS = 'CALIBRATION_LOG_SUCCESS';
export const WARNING_LOG_SUCCESS = 'WARNING_LOG_SUCCESS';
export const CALIBRATION_LOG_FAIL = 'CALIBRATION_LOG_FAIL';
export const WARNING_LOG_FAIL = 'WARNING_LOG_FAIL';
export const LOG_INIT = 'LOG_INIT';

export const calibrationLogRequest = () => {
  return {
    type: CALIBRATION_LOG_REQUEST,
    key: 'calibrationLog',
  };
};

export const warningLogRequest = () => {
  return {
    type: WARNING_LOG_REQUEST,
    key: 'warningLog',
  };
};

export const calibrationLogSuccess = (data) => {
  return {
    type: CALIBRATION_LOG_SUCCESS,
    calibrationLog: data,
  };
};

export const warningLogSuccess = (data) => {
  return {
    type: WARNING_LOG_SUCCESS,
    warningLog: data,
  };
};

export const calibrationLogFail = () => {
  return {
    type: CALIBRATION_LOG_FAIL,
  };
};

export const warningLogFail = () => {
  return {
    type: WARNING_LOG_FAIL,
  };
};

export const logInit = () => {
  return {
    type: LOG_INIT,
  };
};

export const calibrationLogManager = (authIdx) => {
  return (dispatch) => {
    dispatch(calibrationLogRequest());

    return axios
      .get('/api/log/getLimitedCalibration', { params: { authIdx: authIdx } })
      .then((response) => {
        dispatch(calibrationLogSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(calibrationLogFail());
        console.log(error);
      });
  };
};

export const warningLogManager = (authIdx) => {
  return (dispatch) => {
    dispatch(warningLogRequest());

    return axios
      .get('/api/log/getWarning', { params: { resolveStatus: 0, authIdx: authIdx } })
      .then((response) => {
        dispatch(warningLogSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(warningLogFail());
        console.log(error);
      });
  };
};

export const warningLogs = (state = { status: 'WAITING' }, action) => {
  switch (action.type) {
    case 'WARNING_LOG_REQUEST':
      return {
        ...state,
        warningStatus: 'WAITING',
        [action.key]: [],
      };
    case 'CALIBRATION_LOG_REQUEST':
      return {
        ...state,
        calibrationStatus: 'WAITING',
        [action.key]: [],
      };
    case 'CALIBRATION_LOG_SUCCESS':
      return {
        ...state,
        calibrationLog: [...action.calibrationLog],
        calibrationStatus: 'SUCCESS',
      };
    case 'WARNING_LOG_SUCCESS':
      return {
        ...state,
        warningLog: [...action.warningLog],
        warningStatus: 'SUCCESS',
      };
    case 'CALIBRATION_LOG_FAIL':
      return {
        warningStatus: 'FAIL',
      };
    case 'WARNING_LOG_FAIL':
      return {
        warningStatus: 'FAIL',
      };
    case 'LOG_INIT':
      return {
        warningStatus: 'SUCCESS',
        calibrationStatus: 'SUCCESS',
        calibrationLog: [],
        warningLog: [],
      };
    default:
      return state;
  }
};
